<template>
    <div class="" >
        <div class="flex alc" >
            <el-input  class="marr4" style="width: 195px"  v-model="vc_search" :placeholder="'按品名搜索'" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <el-button class="marr4"  @click="addPz" size="mini">{{'新增集团品种'}}</el-button>
        </div>
        <el-table
                v-loading="loading"
                v-if="showTable"
                border
                :data="tableData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                :height="tableHeight"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @selection-change="handleSelectionChange"
                :row-key="row => row.i_pzid"
                :default-selection="defaultSelectedRows"

        >
            <el-table-column
                    align="center"
                    type="selection"
                    :reserve-selection="true"
                    width="50">
            </el-table-column>
            <el-table-column
                    type="index"
                    label=""
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip
            >
                <!--<template slot-scope="scope">
                    <span>{{scope.row.vc_pzname+' '+scope.row.vc_cd+scope.row.vc_gykh+scope.row.vc_bzstyle}}</span>
                </template>-->
            </el-table-column>
            <el-table-column
                    prop="f_list_price"
                    :label="'挂牌价'"
                    show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <el-input-number @change="inprice(tableData,scope.$index,scope.row)"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_list_price" ></el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[30, 50, 100]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button  type="primary" @click="confirm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
        <el-dialog
                :class="baseerp+'div'"
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="15vh"
                width="85%"
                :title="'新增集团品种'"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="onPzConfirm"
                v-if="dialogVisible"
                :append-to-body="true">
            <add-pz  @onPzConfirm="onPzConfirm"></add-pz>
        </el-dialog>
    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import addPz from "./addPz";
    export default {
        name: "",
        components: {
            addPz,
        },
        props: {
            dataOrd: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                dialogVisible:false,
                tableHeight: 350,
                showTable:true,
                tableload:false,
                loading:false,
                vc_search:"",
                valuetime:'',
                baseerp: "",
                mid: 0,
                tableData: [],
                multipleSelection: [],
                pageSize: 30,
                currentPage: 1,
                tableTotal: 0,
                highlightCurrentRow: false,
                deletedIds: [],
                selectedMap:{},
                uniKey:'i_pzid',
                oldList:[],
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        computed: {
            defaultSelectedRows() {
                // 返回当前选中的数据用于 default-selection
                return this.multipleSelection;
            },
        },
        created() {
            //console.log(this.dataOrd,'this.dataOrd')
            this.oldList = this.dataOrd.select;
            const arr = this.dataOrd.select;
            if (arr && Array.isArray(arr)) {
                this.initSelectionFromPrev(arr)
            }
        },
        mounted() {
            this.baseerp = baseerp;
            this.getOrders();

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods: {
            updateTableHeight() {
                //console.log(this.dataOrd.maxDialogHeight,'this.dataOrd.maxDialogHeight');
                const dialogHeight = this.dataOrd.maxDialogHeight ;
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight = 415;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight=dialogHeight;
            },
            addPz(){
                this.dialogVisible=true;
            },
            onPzConfirm(type){
                this.dialogVisible=false;
                if(type){
                    this.getOrders()
                }

            },
            initSelectionFromPrev(arr) {
                //console.log(arr,'arr--')
                arr.forEach(item => {
                    const id = item[this.uniKey]
                    if (!id) return
                    if (!this.selectedMap[id]) {
                        this.selectedMap[id] = true
                        // 深拷贝可避免引用带来的副作用
                        this.multipleSelection.push(Object.assign({}, item))
                    }
                })

                //console.log(' this.selectedMap',this.selectedMap)
                //console.log('this.multipleSelection--',this.multipleSelection)
            },
            inprice(data,index,row){
                if(row.f_list_price <= 0){
                    row.f_list_price = 0;
                    this.$set(data,index,row);
                    this.$message.error('挂牌价不可小于等于0');
                    this.refreshTable();
                    return ;
                }
                this.$set(data,index,row);
                const idx = this.multipleSelection.findIndex(item => item.i_pzid === row.i_pzid);
                if (idx >= 0) this.$set(this.multipleSelection, idx, { ...row });

            },
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getOrders();
                //console.log(this.multipleSelection,'multipleSelection')
            },
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                    this.restoreSelection()
                })
            },
            restoreSelection() {
                this.$nextTick(() => {
                    this.multipleSelection.forEach(selectedRow => {
                        const matched = this.tableData.find(item => item.i_pzid === selectedRow.i_pzid);
                        if (matched) {
                            this.$refs.table.toggleRowSelection(matched, true);
                        }
                    });
                });
            },
            handleSelectionChange(currentSelectedRows) {
                if(!this.tableload)return;
                currentSelectedRows.forEach(row => {
                    const id = row[this.uniKey]
                    //console.log('id',id)
                    //console.log('this.selectedMap[id]',this.selectedMap[id])
                    if (!this.selectedMap[id]) {
                        this.selectedMap[id] = true
                        this.multipleSelection.push(Object.assign({}, row))
                    }
                })
                const selectedIdsOnPage = new Set(currentSelectedRows.map(r => r[this.uniKey]))
                this.tableData.forEach(row => {
                    const id = row[this.uniKey]
                    if (!id) return
                    if (this.selectedMap[id] && !selectedIdsOnPage.has(id)) {
                        row.f_list_price=0;
                        //console.log(row,'row')
                        this.removeFromMulselectionById(id)
                    }
                })
                //console.log('this.multipleSelection-select',this.multipleSelection)
            },
            removeFromMulselectionById(id) {
                if (!this.selectedMap[id]) return
                delete this.selectedMap[id]
                const idx = this.multipleSelection.findIndex(it => it[this.uniKey] === id)
                if (idx !== -1) this.multipleSelection.splice(idx, 1)
                /*if(!this.deletedIds.includes(id)){
                    this.deletedIds.push(id)
                }*/

                /*if (!this.selectedMap[id]) return
                const idx = this.multipleSelection.findIndex(it => it[this.uniKey] === id)
                let removedRow = null
                if (idx !== -1) {
                    removedRow = this.multipleSelection[idx]
                    this.multipleSelection.splice(idx, 1)
                }
                delete this.selectedMap[id]
                console.log('removedRow.i_id',removedRow.i_id)
                if (removedRow && removedRow.i_id!=0) {
                    console.log("1")
                    const id = removedRow.i_id
                    if (!this.deletedIds.includes(id)) {
                        console.log('2')
                        this.deletedIds.push(id)
                    }
                }*/
                //console.log(this.deletedIds,'this.deletedIds')
            },
            async getOrders(){
                this.loading=true;
                let param = {
                    'i_mid':this.mid,
                    'i_khid':this.dataOrd.i_khid,
                    'i_gsid':this.dataOrd.i_gsid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'dt_starttime':this.dataOrd.dt_starttime+' 00:00:00',
                    'dt_endtime':this.dataOrd.dt_endtime+' 23:59:59',
                    'vc_search':this.vc_search,

                };
                let res = await API.getpzlist(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData = res.data;
                    this.tableTotal = res.total;
                    this.$nextTick(() => {
                        const table = this.$refs.table;
                        if (table) {
                            this.tableData.forEach(row => {
                                row.f_list_price=0;
                                const isSelected = this.multipleSelection.some(sel => sel.i_pzid == row.i_pzid);
                                table.toggleRowSelection(row, isSelected);
                                const idx = this.multipleSelection.findIndex(i => i.i_pzid === row.i_pzid)
                                ////console.log(idx,'idx')
                                if (idx !== -1 && isSelected) {
                                    row.f_list_price=this.multipleSelection[idx].f_list_price;
                                    //this.multipleSelection.push(row);
                                    this.$set(this.multipleSelection, idx, { ...row, ...this.multipleSelection[idx] })
                                }
                                const delidx = this.dataOrd.del.findIndex(sel => sel === row.i_id);
                                if(delidx!=-1){
                                    row.f_list_price=0;
                                }
                            });
                        }
                        this.tableload=true;
                    });
                    //console.log(this.tableData);
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getOrders();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getOrders();
            },
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_starttime= this.formatDate( this.valuetime[0]);
                this.dt_endtime= this.formatDate( this.valuetime[1]);
                this.getOrders();
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_starttime= this.formatDate(e[0]);
                    this.dt_endtime= this.formatDate(e[1]);
                    //console.log(this.dt_starttime,this.dt_endtime);
                }else{
                    this.dt_starttime= '';
                    this.dt_endtime= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.getOrders();
            },
            confirm() {
                //console.log('this.multipleSelection',this.multipleSelection)
                if(this.multipleSelection.length==0){
                    this.$message.error('请选择挂牌品种');return;
                }else{
                    let has0 = this.multipleSelection.some(item=>item.f_list_price==0)
                    if(has0){this.$message.error('挂牌价不可为0');return;}
                }
                const diff = this.diffList(this.oldList,this.multipleSelection);
                //console.log('diff',diff)
                this.$emit('onPzConfirm',diff,true)
                //this.$emit('onPzConfirm', this.multipleSelection,this.deletedIds,true)

            },
            cancel(){
                this.$emit('onPzConfirm');
            },
            diffList(oldList, newList) {
                const oldMap = new Map(oldList.map(o => [o.i_pzid, o]));
                //console.log('oldMap',oldMap)
                const addList = [];
                const editList = [];
                const removeList = [];
                const delIds = [];
                newList.forEach(row => {
                    const oldRow = oldMap.get(row.i_pzid);
                    if (!oldRow) {
                        addList.push(row);
                    } else {
                        const isChanged = JSON.stringify(oldRow) !== JSON.stringify(row);
                        if (isChanged) {
                            editList.push({
                                ...oldRow,
                                ...row     // 新的数据覆盖旧的
                            });
                        }
                    }
                });
                const newIds = newList.map(n => n.i_pzid);
                oldList.forEach(oldRow => {
                    if (!newIds.includes(oldRow.i_pzid)) {
                        removeList.push(oldRow);
                        if (oldRow.i_id) {
                            delIds.push(oldRow.i_id);
                        }
                    }
                });

                return {
                    addList,
                    editList,
                    removeList,
                    delIds
                };
            },

        }
    }
</script>
<style>
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>


    /* 隐藏 el-table 的全选框 */
    /deep/ .el-table__header-wrapper th .cell .el-checkbox {
        display: none;
    }



    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }

    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }

    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }


    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
